// extracted by mini-css-extract-plugin
export default {"container":"selections_container__3u9Nb","title":"selections_title__3v14V","section":"selections_section__1EdLz","selection":"selections_selection__jCC5O"};